<app-tst-expo-banner></app-tst-expo-banner>
<div class="search-container-small d-flex align-items-center justify-content-center px-3">
  <div class="search-bar d-flex d-lg-none">
    <!-- <input class="search-input small" type="text" placeholder="Search Products" [(ngModel)]="searchValue"
                    (keydown.enter)="onClickSearch()" (input)="onchangeInput()">
                <div class="search-icon-svg">
                    <img class="search-icon" src="search.svg" alt="" (click)="onClickSearch()">
                </div> -->
  </div>
</div>
<!-- ===== Hero section (new design) ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('hero')">
    <!-- Hero (Web UI Kit sizes): ruler, copy left, photo on a diagonal right, then the ink stats band. -->
    <section class="hero">
      <div class="hero-ruler" aria-hidden="true"></div>
      <!-- One image carries the light panel, the diagonal stripes and the photo (Figma export). -->
      <picture class="hero-media" aria-hidden="true">
        <source type="image/webp" srcset="FirstScreen.webp" />
        <img class="hero-photo" src="FirstScreen.png" alt="" width="2006" height="1087" fetchpriority="high" />
      </picture>
      <div class="container hero-content">
        <div class="hero-copy">
          <p class="hero-eyebrow"><span class="hero-eyebrow-num">01</span>The S&amp;F experience</p>
          <h1 class="hero-title">Find it faster. <span class="hero-title-accent">Get it fastest.</span></h1>
          <p class="hero-subtitle">Every last thing you need to run your <strong>signage</strong>,
            <strong>awning</strong>, or <strong>marine</strong> business. Stocked in Brooklyn, picked today.</p>
          <div class="hero-actions">
            <a class="hero-cta hero-cta-primary" routerLink="/category">Shop by category
              <img src="/images/svg/home/hero-arrow.svg" alt="" width="16" height="16" aria-hidden="true" />
            </a>
            <a class="hero-cta hero-cta-outline" routerLink="/search">All products</a>
          </div>
          <ul class="hero-meta">
            <li>
              <img src="/images/svg/home/hero-pin.svg" alt="" width="16" height="16" aria-hidden="true" />
              Brooklyn, NY since 1985
            </li>
            <li>
              <img src="/images/svg/home/hero-user.svg" alt="" width="16" height="16" aria-hidden="true" />
              12,000+ contractors
            </li>
            <li>
              <img src="/images/svg/home/hero-star.svg" alt="" width="16" height="16" aria-hidden="true" />
              300+ brands
            </li>
          </ul>
        </div>
        <app-cutoff-card class="hero-cutoff"></app-cutoff-card>
      </div>
    </section>

    <section class="hero-stats" aria-label="S&F at a glance">
      <div class="container hero-stats-grid">
        <div class="hero-stat">
          <img src="/images/svg/home/stat-skus.svg" alt="" width="36" height="36" aria-hidden="true" />
          <div>
            <p class="hero-stat-value">20,000+</p>
            <p class="hero-stat-label">SKUs in stock</p>
            <p class="hero-stat-note">One stockroom in Brooklyn</p>
          </div>
        </div>
        <div class="hero-stat">
          <img src="/images/svg/home/stat-ship.svg" alt="" width="36" height="36" aria-hidden="true" />
          <div>
            <p class="hero-stat-value">2 PM</p>
            <p class="hero-stat-label">Most orders ship today</p>
            <p class="hero-stat-note">Cut-off 2:00 PM ET</p>
          </div>
        </div>
        <div class="hero-stat">
          <img src="/images/svg/home/stat-inhouse.svg" alt="" width="36" height="36" aria-hidden="true" />
          <div>
            <p class="hero-stat-value">In-house</p>
            <p class="hero-stat-label">Rapid custom processing</p>
            <p class="hero-stat-note">Cut-to-size &amp; fabrication</p>
          </div>
        </div>
        <div class="hero-stat">
          <img src="/images/svg/home/stat-tiered.svg" alt="" width="36" height="36" aria-hidden="true" />
          <div>
            <p class="hero-stat-value">Tiered</p>
            <p class="hero-stat-label">Account-based savings</p>
            <p class="hero-stat-note">Contractor pricing tiers</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Ampersand Line (style guide "ONE-STOP SHOP"): categories joined by the "&", a slow marquee.
         Two identical sets scroll -50% for a seamless loop; the copy is hidden from screen readers. -->
    @let ampItems = ['Vinyl', 'Substrates', 'Inks', 'Awning fabric', 'LED modules', 'Banner media'];
    <section class="amp-line" aria-label="Vinyl, substrates, inks, awning fabric, LED modules and banner media">
      <div class="amp-track">
        @for (copy of [0, 1]; track copy) {
        <div class="amp-set" [attr.aria-hidden]="true">
          @for (item of ampItems; track item) {
          <span class="amp-word">{{ item }}</span><span class="amp-sep">&amp;</span>
          }
        </div>
        }
      </div>
    </section>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('hero')" part="hero" [class.sk-layer--out]="skFading('hero')"></app-home-skeleton>
</div>

<!-- ===== 02 Six industries (Wireframe_v2) ===== -->
<section class="ind-section">
  <div class="container ind-inner">
    <div class="ind-intro">
      <p class="hero-eyebrow"><span class="hero-eyebrow-num">02</span>Six industries</p>
      <h2 class="ind-title">In the business of supplying yours.</h2>
      <p class="ind-text">Our turnkey products, services, and support help you start, run, and grow in six trades
        we've mastered since 1985.</p>
      <a class="ind-link" routerLink="/category">All industries
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
        </svg>
      </a>
    </div>

    <div class="ind-grid">
      @for (ind of industries; track ind.no) {
      <a class="ind-card" [routerLink]="ind.link">
        <div class="ind-media">
          <picture>
            @if (ind.webp !== false) {
            <source type="image/webp" [attr.srcset]="'/images/' + ind.img + '.webp'" />
            }
            <img [src]="'/images/' + ind.img + '.png'" alt="" loading="lazy" decoding="async" />
          </picture>
          <span class="ind-no">{{ ind.no }}</span>
        </div>
        <div class="ind-body">
          <div>
            <h3 class="ind-card-title">{{ ind.title[0] }}<br />{{ ind.title[1] }}</h3>
            <p class="ind-sub">{{ ind.sub }}</p>
          </div>
          <span class="ind-link ind-cta">{{ ind.cta }}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
            </svg>
          </span>
        </div>
      </a>
      }
    </div>
  </div>
</section>

<!-- ===== 03 300+ performance brands (Wireframe_v2) ===== -->
<section class="pb-section">
  <div class="container">
    <div class="pb-head">
      <div>
        <p class="hero-eyebrow"><span class="hero-eyebrow-num">03</span>300+ performance brands</p>
        <h2 class="pb-title">Bestsellers. Exclusives. Firsts.</h2>
      </div>
      <div class="pb-controls">
        <a class="ind-link pb-shop" routerLink="/brands">Shop by brand
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </a>
        <button type="button" class="pb-arrow" [disabled]="!brandCanPrev" (click)="scrollBrands(-1)"
          aria-label="Previous brands">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="m15 6-6 6 6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </button>
        <button type="button" class="pb-arrow" [disabled]="!brandCanNext" (click)="scrollBrands(1)"
          aria-label="Next brands">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </button>
      </div>
    </div>

    <div #brandRow class="pb-row" (scroll)="updateBrandArrows()" (window:resize)="updateBrandArrows()">
      <!-- Real catalogue brands (those with a logo); each opens its brand page. Six blank
           cards hold the row's height until the browser-only /Brands call lands. -->
      @for (b of brands; track b.slug) {
      <a class="pb-card" [routerLink]="['/brand', b.slug]" [attr.aria-label]="b.name" [title]="b.name">
        <img [src]="b.imageUrl" [alt]="b.name" loading="lazy" />
      </a>
      } @empty {
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
      <span class="pb-card pb-card--placeholder" aria-hidden="true"></span>
      }
      }
    </div>
  </div>
</section>

<!-- ===== How It Works ===== -->
<!-- <div class="sk-crossfade">
  <ng-container *ngIf="skReady('hiw')">
    <div [class.sk-content--in]="skFadeIn('hiw')">
      <section #hiwSection class="hiw" [class.hiw-animate]="hiwReady" [class.in-view]="hiwInView">
        <div class="container why-inner">
          <p class="section-label">How it works</p>
          <h2 class="section-heading">From order to fulfillment in 4 steps</h2>
          <div class="hiw-steps">
            @for (step of hiwSteps; track step; let i = $index; let last = $last) {
            <div class="hiw-step" [style.--i]="i">
              <div class="hiw-circle-wrap">
                <div class="hiw-circle">{{ i + 1 }}</div>
              </div>
              <p class="hiw-label">{{ step }}</p>
            </div>
            @if (!last) {
           
            <span class="hiw-connector" [style.--i]="i" aria-hidden="true">
              <svg class="hiw-conn-line hiw-conn-h" width="193" height="23" viewBox="0 0 193 23" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="11.8" x2="193" y2="11.8" stroke="#57A9D0" stroke-width="1.5"
                  stroke-dasharray="4.05 4.05" stroke-dashoffset="2.03" />
              </svg>
              <svg class="hiw-conn-head hiw-conn-h" width="12" height="23" viewBox="0 0 12 23" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 2.8 L10 11.8 L1.5 20.8" stroke="#57A9D0" stroke-width="3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            
              <svg class="hiw-conn-line hiw-conn-v" width="2" height="58" viewBox="0 0 2 58" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <line x1="1" y1="0" x2="1" y2="58" stroke="#57A9D0" stroke-width="1.5" stroke-dasharray="4.05 4.05"
                  stroke-dashoffset="2.03" />
              </svg>
              <svg class="hiw-conn-head hiw-conn-v" width="23" height="12" viewBox="0 0 23 12" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M2.8 1.5 L11.5 10.2 L20.2 1.5" stroke="#57A9D0" stroke-width="3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            }
            }
          </div>
          <a class="hero-btn hero-btn-primary hiw-cta" routerLink="/search">Browse Products</a>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('hiw')" part="hiw" [class.sk-layer--out]="skFading('hiw')"></app-home-skeleton>
</div> -->

<!-- ===== Explore Categories ===== -->
<!-- <div class="sk-crossfade">
  <ng-container *ngIf="skReady('categories')">
    <div [class.sk-content--in]="skFadeIn('categories')">
      <section class="cat-section">
        <div class="container">
          <h2 class="section-heading cat-heading">Explore categories. <span class="cat-heading-muted">Find what you
              need.</span></h2>
          <div class="cat-grid">
            @for (cat of categories; track cat.title) {
            <a class="cat-card" [routerLink]="cat.link">
              <div class="cat-card-img">
                <img [src]="cat.image" [alt]="cat.title" loading="lazy" />
              </div>
              <div class="cat-card-text">
                <h3 class="cat-card-title">{{ cat.title }}</h3>
                <p class="cat-card-subtitle">{{ cat.subtitle }}</p>
              </div>
            </a>
            }
          </div>
          <div class="cat-cta-wrap">
            <a class="hero-btn hero-btn-primary" routerLink="/search">Browse all products
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('categories')" part="categories"
    [class.sk-layer--out]="skFading('categories')"></app-home-skeleton>
</div> -->

<!-- ===== Featured Products ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('featured')">
    <div [class.sk-content--in]="skFadeIn('featured')">
      <!-- 04 Featured & for you (Wireframe_v2). Same featuredProducts data and shared carousel. -->
      <section class="featured-section">
        <div class="container">
          <div class="pb-head">
            <div>
              <p class="hero-eyebrow"><span class="hero-eyebrow-num">04</span>Just the things you need</p>
              <h2 class="pb-title">Featured &amp; for you</h2>
              @if (!isLogin) {
              <p class="fy-note"><a routerLink="/login">Sign in</a> for recommendations based on your recent
                searches and previous projects.</p>
              }
            </div>
            @if (featuredProducts?.length > 1) {
            <div class="pb-controls">
              <button type="button" class="pb-arrow pb-arrow--ghost" (click)="fy.prev()" aria-label="Previous products">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="m15 6-6 6 6 6" stroke="currentColor" stroke-width="2" />
                </svg>
              </button>
              <button type="button" class="pb-arrow" (click)="fy.next()" aria-label="Next products">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2" />
                </svg>
              </button>
            </div>
            }
          </div>
          <app-featured-carousel #fy [hidden]="!featuredProducts?.length" [items]="featuredProducts"
            [signedIn]="isLogin" [showDots]="false"></app-featured-carousel>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('featured')" part="featured"
    [class.sk-layer--out]="skFading('featured')"></app-home-skeleton>
</div>

<!-- ===== 05 Bestselling categories (Wireframe_v2) ===== -->
<section class="pop-section">
  <div class="container">
    <div class="pop-rule" aria-hidden="true"></div>
    <div class="pb-head">
      <div>
        <p class="hero-eyebrow"><span class="hero-eyebrow-num">05</span>Bestselling categories</p>
        <h2 class="pb-title">Popular by demand.</h2>
      </div>
      <div class="pop-links">
        <a class="ind-link" routerLink="/product/list">Browse all products
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </a>
        <a class="ind-link" routerLink="/search">Instant quote search
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </a>
      </div>
    </div>

    <div class="pop-grid">
      @for (cat of popularCategories; track cat.no) {
      <a class="pop-card" [routerLink]="cat.link">
        <div class="pop-meta">
          <span>{{ cat.no }}</span>
          @if (cat.skus) {
          <span>{{ cat.skus }} SKUs</span>
          }
        </div>
        <div class="pop-media">
          <img [src]="categoryImageBase + cat.img" alt="" loading="lazy" decoding="async" />
        </div>
        <div class="pop-foot">
          <h3 class="pop-title">{{ cat.title }}</h3>
          <svg class="pop-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" />
          </svg>
        </div>
      </a>
      }
    </div>
  </div>
</section>

<!-- ===== 06 #1 in Brooklyn (Wireframe_v2 1:3005) ===== -->
<app-home-why></app-home-why>

<!-- ===== 08 Client companies (Wireframe_v2 1:3583) =====
     Replaces the old "Companies we work with" wall. Logos are the real partner companies from
     /website-sections (Figma's Atlas / Northline / Vector / Union were placeholders), drawn as
     ink silhouettes in Figma's 8 x 128px cell grid. Blank cells hold the size until they load. -->
@if (!companiesLoaded || companyLogos.length) {
<section class="clients-section">
  <div class="container">
    <div class="clients-rule" aria-hidden="true"></div>
    <p class="hero-eyebrow"><span class="hero-eyebrow-num">08</span>Client companies</p>
    <h2 class="pb-title clients-title">These industry professionals<br />insist on S&amp;F Supplies.</h2>
    <ul class="clients-grid">
      @for (c of companyLogos; track c.id) {
      <li class="clients-cell">
        <img class="clients-logo" [src]="c.src" [alt]="c.name" [title]="c.name" loading="lazy" />
      </li>
      } @empty {
      @for (i of clientPlaceholders; track i) {
      <li class="clients-cell" aria-hidden="true"></li>
      }
      }
    </ul>
  </div>
</section>
}

<!-- ===== 09 Our mission / "Because you need it" (Wireframe_v2 1:3682) =====
     Replaces the old "Built for Speed and Scale" story. In Figma it sits after the client logos;
     it moves there once those sections are built. -->
<section class="mission-section">
  <span class="mission-sf" aria-hidden="true"></span>
  <div class="container mission-inner">
    <div class="mission-copy">
      <p class="hero-eyebrow"><span class="hero-eyebrow-num">09</span>Our mission</p>
      <h2 class="mission-title">Because you<br />need it<sup>™</sup></h2>
      <p class="mission-text">We stay close to the heavy lifting so we can do it for you. When we get that right, you're
        left with a lighter load and more room to say yes to the most exciting, profitable projects in your pipeline.
        We're not a silent partner. We're a working one: we handle the noise, the turnarounds, the price comparisons
        and the wait times.</p>
      <p class="mission-note">It's all we've done for the past 40 years.</p>
      <div class="mission-actions">
        <a class="hero-cta hero-cta-outline" routerLink="/about">History &amp; team
          <span class="mission-arrow" aria-hidden="true"></span>
        </a>
      </div>
    </div>
    <div class="mission-media">
      <div class="mission-photo" role="img" aria-label="An S&F driver reviewing an order with a customer"></div>
      <div class="mission-badge">
        <span class="mission-badge-since">Since</span>
        <span class="mission-badge-year">1985</span>
        <span class="mission-badge-place">Brooklyn, NY</span>
      </div>
      <p class="mission-years">40<span>yrs</span></p>
    </div>
  </div>
</section>

<!-- ===== Still looking? Just ask (Wireframe_v2 ASK) ===== -->
<app-home-ask></app-home-ask>

<!-- ===== OLD SECTIONS (not in Wireframe_v2) — switched off, not deleted =====
     Modify, Brands marquee, Testimonials, Recently bought, Companies, Numbers, Story,
     Insights, FAQ. Delete this whole block (and showLegacySections) once the new homepage
     is signed off. -->
@if (showLegacySections) {
<!-- ===== Modify Your Materials (S&F services) ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('modify')">
    <div [class.sk-content--in]="skFadeIn('modify')">
      <section class="modify-wrap">
        <div class="container">
          <div class="modify-section">
            <div class="modify-head text-center">
              <p class="section-label">S&F services</p>
              <h2 class="section-heading">Modify your materials</h2>
            </div>
            <div class="modify-cards">
              @for (svc of modifyServices; track svc.title) {
              <div class="modify-card">
                <div class="modify-card-face">
                  <div class="modify-card-main">
                    <div class="modify-card-icon">
                      <img [src]="svc.icon" [alt]="svc.title" />
                    </div>
                    <h3 class="modify-card-title">{{ svc.title }}</h3>
                  </div>
                  <p class="modify-card-desc">{{ svc.desc }}</p>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('modify')" part="modify"
    [class.sk-layer--out]="skFading('modify')"></app-home-skeleton>
</div>

<!-- ===== Seasonal Promo (Seasonal Material Discount) — Figma node 13845:314169 ===== -->
<!-- TEMP DISABLED — no backend yet; uncomment to re-enable:
    <section class="promo-section">
      <div class="promo-copy">
        <div class="promo-text">
          <div class="promo-heading-block">
            <p class="promo-label">Seasonal Promotions</p>
            <h2 class="promo-heading">Seasonal Material Discount</h2>
          </div>
          <p class="promo-subtitle">Discounted pricing on select materials during peak season periods</p>
        </div>
        <button type="button" class="hero-btn hero-btn-primary promo-btn" routerLink="/product/list">
          View eligible products
        </button>
      </div>
      <div class="promo-media">
        <img class="promo-img" src="/images/seasonal-promo.png" alt="Stack of metal sheets" loading="lazy" />
      </div>
    </section>
    -->
<!-- === /Seasonal Material Discount === -->

<!-- ===== Brands we carry (Figma node 13845:314180) — continuous logo marquee ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('brands')">
    <div [class.sk-content--in]="skFadeIn('brands')">
      <section class="brands-section">
        <div class="container">
          <div class="brands-top">
            <h2 class="brands-heading">Brands we carry. <span>Trusted Manufacturers.</span></h2>
            <div class="brands-marquee">
              <div class="brands-track">
                @for (rep of [0, 1]; track rep) {
                <div class="brands-set" [attr.aria-hidden]="rep === 1 ? 'true' : null">
                  @for (b of marqueeBrands; track $index) {
                  <!-- Real link (not a click handler) so touch devices reliably get :active,
                   which is what shows the light background + shadow on tap. -->
                  <a class="brand-chip" [routerLink]="['/brand', b.slug]" [attr.aria-label]="b.name">
                    <img class="brand-logo" [src]="b.imageUrl" [alt]="b.name" loading="lazy" />
                  </a>
                  }
                </div>
                }
              </div>
            </div>
          </div>
          <a class="hero-btn hero-btn-primary brands-cta" routerLink="/brands">
            Shop by brand
          </a>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('brands')" part="brands"
    [class.sk-layer--out]="skFading('brands')"></app-home-skeleton>
</div>

<!-- ===== Testimonials carousel (Figma node 13845:314525) ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('testimonials')">
    <div [class.sk-content--in]="skFadeIn('testimonials')">
      <section class="tm-section" *ngIf="testimonials.length">
        <div class="container tm-inner pb-lg-5">
          <div class="tm-head">
            <p class="tm-label">What our customers say</p>
            <h2 class="tm-heading">What contractors are saying about S&F</h2>
          </div>
          <div class="tm-carousel">
            <div class="tm-viewport" (mouseenter)="stopTestimonialAutoplay()" (mouseleave)="startTestimonialAutoplay()">
              <div class="tm-track" [style.transform]="'translateX(-' + (activeTestimonial * 100) + '%)'">
                @for (slide of testimonialSlides; track $index) {
                <!-- is-active drives the mobile carousel's highlighted card (the peeking
                 neighbour stays muted); it's inert at desktop widths. -->
                <div class="tm-slide" [class.is-active]="$index === activeTestimonial">
                  @for (t of slide; track t.id) {
                  <article class="tm-card">
                    <p class="tm-quote">{{ t.quote }}</p>
                    <div class="tm-author">
                      <div class="tm-avatar" [class.tm-avatar--photo]="t.image" aria-hidden="true">
                        <img *ngIf="t.image" class="tm-avatar-img" [src]="t.image" [alt]="t.name" loading="lazy" />
                        <span *ngIf="!t.image" class="tm-avatar-initials">{{ t.initials }}</span>
                      </div>
                      <div class="tm-author-meta">
                        <p class="tm-name">{{ t.name }}</p>
                        <p class="tm-role">{{ t.role }}</p>
                        <p class="tm-company">{{ t.company }}</p>
                      </div>
                    </div>
                  </article>
                  }
                </div>
                }
              </div>
            </div>
            <div class="tm-dots">
              @for (slide of testimonialSlides; track $index) {
              <button type="button" class="tm-dot" [class.active]="$index === activeTestimonial"
                (click)="goToTestimonial($index)"
                [attr.aria-label]="'Go to testimonials slide ' + ($index + 1)"></button>
              }
            </div>
          </div>
          <a class="hero-btn hero-btn-primary tm-cta" routerLink="/register">
            Register as a customer
          </a>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('testimonials')" part="testimonials"
    [class.sk-layer--out]="skFading('testimonials')"></app-home-skeleton>
</div>
<!-- === /What contractors are saying about S&F === -->

<!-- Homepage: marketing variant — existing customers only, Featured-style cards. -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('recent')">
    <div [class.sk-content--in]="skFadeIn('recent')">
      <div class="container">
        <app-recent-view [homepage]="true"></app-recent-view>
      </div>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('recent')" part="recent"
    [class.sk-layer--out]="skFading('recent')"></app-home-skeleton>
</div>

<!-- ===== Companies we work with (Figma node 13845:314580) — navy logo wall ===== -->

<div class="sk-crossfade">
  <ng-container *ngIf="skReady('companies')">
    <div [class.sk-content--in]="skFadeIn('companies')">
      <section class="companies-section" *ngIf="companyLogos.length">
        <div class="container">
          <div class="companies-head">
            <p class="companies-label">Companies we work with</p>
            <h2 class="companies-heading">Trusted by Industry Professionals</h2>
          </div>
          <div class="companies-grid">
            @for (c of companyLogos; track c.id) {
            <span class="cw-logo" [style.--m]="'url(' + c.src + ')'" [attr.aria-label]="c.name">
              <img [src]="c.src" [alt]="c.name" loading="lazy" />
            </span>
            }
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('companies')" part="companies"
    [class.sk-layer--out]="skFading('companies')"></app-home-skeleton>
</div>
<!-- === /Trusted by Industry Professionals === -->

<!-- ===== S&F in Numbers (Figma node 13845:314770) — count-up on scroll ===== -->

<div class="sk-crossfade">
  <ng-container *ngIf="skReady('numbers')">
    <div [class.sk-content--in]="skFadeIn('numbers')">
      <section class="numbers-section" #numbersSection [class.numbers-js]="numbersJs"
        [class.numbers-animate]="numbersInView">
        <div class="container">
          <div class="numbers-head">
            <p class="numbers-label">S&F in numbers</p>
            <h2 class="numbers-heading">Built to support contractors at scale since 1985</h2>
          </div>
          <div class="numbers-grid">
            @for (s of numbersStats; track s.label; let i = $index) {
            <div class="num-card" [style.--i]="i">
              <div class="num-bg"><img [src]="s.bg" alt="" aria-hidden="true" loading="lazy" /></div>
              <div class="num-content">
                <div class="num-figure">
                  <p class="num-value">{{ formatStat(numbersDisplay[i]) }}{{ s.suffix }}</p>
                  <p class="num-label">{{ s.label }}</p>
                </div>
                <p class="num-text">{{ s.text }}</p>
              </div>
            </div>
            }
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('numbers')" part="numbers"
    [class.sk-layer--out]="skFading('numbers')"></app-home-skeleton>
</div>

<!-- ===== Our Story (Figma node 13845:314806) — copy column beside looping warehouse
     footage, with the dot-grid and glow sitting behind the video. Content comes from
     the our-story API; the section is dropped entirely when nothing is published. ===== -->

<div class="sk-crossfade">
  <ng-container *ngIf="skReady('story')">
    <div [class.sk-content--in]="skFadeIn('story')">
      <section class="story-section" *ngIf="story">
        <div class="container story-inner">
          <div class="story-copy">
            <p class="story-eyebrow" *ngIf="story.tagline">{{ story.tagline }}</p>
            <h2 class="story-heading">{{ story.header }}</h2>
            <p class="story-body">{{ story.description }}</p>
            <a class="story-cta" routerLink="/about">
              <span class="story-cta-text">Explore Our Story</span>
              <svg class="story-cta-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
          <div class="story-media-wrap">
            <div class="story-dots" aria-hidden="true"></div>
            <div class="story-glow" aria-hidden="true"></div>
            <div class="story-media">
              <!-- No video on the record → the media keeps its navy gradient (see .story-media). -->
              <video class="story-video" *ngIf="story.videoUrl" [src]="story.videoUrl" autoplay loop muted playsinline
                preload="metadata"></video>
            </div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('story')" part="story" [class.sk-layer--out]="skFading('story')"></app-home-skeleton>
</div>

<!-- ===== Insights & industry updates (Figma node 13845:316163) — featured post +
     vertically-scrollable list, colour-coded tags, staggered scroll reveal. ===== -->

@if (insightsPosts.length) {
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('insights')">
    <div [class.sk-content--in]="skFadeIn('insights')">
      <section class="insights-section" #insightsSection [class.insights-js]="insightsJs"
        [class.insights-animate]="insightsInView">
        <div class="container">
          <div class="insights-head">
            <p class="insights-label">Insights &amp; industry updates</p>
            <h2 class="insights-heading">Stay informed. <span>Work smarter.</span></h2>
          </div>
          <div class="insights-grid">
            @if (insightsPosts[0]; as f) {
            <a class="insight-card insight-featured" [style.--i]="0" [routerLink]="f.link">
              <div class="insight-inner">
                <div class="insight-featured-thumb"><img [src]="f.image" [alt]="f.title" loading="lazy" /></div>
                <div class="insight-featured-body">
                  <div class="insight-tagrow">
                    <span [class]="'insight-tag ' + insightTagClass(f.category)">{{ f.category }}</span>
                    <div class="insight-meta"><span>by S&amp;F Supplies</span><span *ngIf="f.date">{{ f.date |
                        date:'mediumDate' }}</span><span *ngIf="f.read">{{ f.read }}</span></div>
                  </div>
                  <h3 class="insight-featured-title">{{ f.title }}</h3>
                  <p class="insight-featured-excerpt" *ngIf="f.excerpt">{{ f.excerpt }}</p>
                </div>
                <span class="insight-more">Read More
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
              </div>
            </a>
            }
            <!-- is-scrollable (measured, not counted) gates the bottom fade — it's a scroll
           hint, so it only makes sense once the list actually overflows. -->
            <div class="insights-list-wrap" [class.is-scrollable]="insightsScrollable">
              <div class="insights-list" #insightsList *ngIf="insightsPosts.length > 1">
                @for (p of insightsPosts.slice(1); track p.title; let i = $index) {
                <a class="insight-card insight-item" [style.--i]="i + 1" [routerLink]="p.link">
                  <div class="insight-inner">
                    <div class="insight-item-thumb"><img [src]="p.image" [alt]="p.title" loading="lazy" /></div>
                    <div class="insight-item-body">
                      <span [class]="'insight-tag ' + insightTagClass(p.category)">{{ p.category }}</span>
                      <h3 class="insight-item-title">{{ p.title }}</h3>
                      <div class="insight-meta"><span>by S&amp;F Supplies</span><span *ngIf="p.date">{{ p.date |
                          date:'mediumDate' }}</span><span *ngIf="p.read">{{ p.read }}</span></div>
                      <span class="insight-more">Read More
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </a>
                }
              </div>
            </div>
          </div>
          <div class="insights-cta-wrap">
            <a class="hero-btn hero-btn-primary insights-cta" routerLink="/blog">
              View All Articles
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('insights')" part="insights"
    [class.sk-layer--out]="skFading('insights')"></app-home-skeleton>
</div>
}
<!-- === /Stay informed. Work smarter. === -->

<!-- ===== FAQ accordion (Figma node 13845:316245) — dot-grid bg, expand/collapse. ===== -->
<div class="sk-crossfade">
  <ng-container *ngIf="skReady('faq')">
    <div [class.sk-content--in]="skFadeIn('faq')">
      <section class="faq-section" *ngIf="faqs.length">
        <div class="container faq-inner">
          <div class="faq-head">
            <p class="faq-label">Before You Order</p>
            <h2 class="faq-heading">Frequently Asked Questions</h2>
          </div>
          <div class="faq-list">
            @for (f of faqs; track f.id; let i = $index) {
            <div class="faq-item" [class.open]="faqOpen === i">
              <button type="button" class="faq-q" (click)="toggleFaq(i)" [attr.aria-expanded]="faqOpen === i">
                <span class="faq-question">{{ f.q }}</span>
                <svg class="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
              </button>
              <div class="faq-answer-wrap">
                <div class="faq-answer-inner">
                  <p class="faq-answer">{{ f.a }}</p>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  <app-home-skeleton *ngIf="skShow('faq')" part="faq" [class.sk-layer--out]="skFading('faq')"></app-home-skeleton>
</div>
<!-- === /Frequently Asked Questions === -->
}
<!-- ===== /OLD SECTIONS ===== -->
<!-- <app-shipping-fees-modal #popupShipFees [cart]="feesCart"></app-shipping-fees-modal> -->

<!-- <div class="cartpopup" [class.active]="addedToCart">
      <div class="d-flex justify-content-end">
          <a
            style="opacity: 1;"
            type="button"
            class="btn-close"
            (click)="closeAddtocart()"
          ></a>
      </div>
     <div>
      <div class="product d-flex">
        <img class="me-2" [src]="addedItem?.imageUrl ? addedItem.imageUrl:'./placeholder.svg'" alt="">
        <div class="w-100 d-flex flex-column justify-content-between">
          <h4 class="itemHeading">Item added to cart</h4>
          <div class="pname d-flex justify-content-between"><h5>{{addedItem?.productName}}</h5><span>{{addedItem?.price | currency:'USD'}}</span></div>
        </div>
       </div>
      </div>
      <div class="actionBtns d-flex mt-3">
        <button  (click)="closeAddtocart()" >keep Shopping</button>
        <button (click)="closeAddtocart()" routerLink="/shopping-cart">VIEW CART</button>
      </div>
</div> -->